import type { UsersItemProps } from 'components/user/Records/components/UsersItem.tsx';
import { UsersItem } from 'components/user/Records/components/UsersItem.tsx';
import { get, useFormContext } from 'react-hook-form';
import { memo } from 'react';
import type { FormItemDefinition } from 'types';

export type UsersItemEditableProps = {
  id: string;
  definition?: FormItemDefinition;
  agendaId?: string;
} & UsersItemProps;

const UsersItemEditableBase = (props: UsersItemEditableProps) => {
  const {
    formState: { errors },
  } = useFormContext();

  return <UsersItem error={get(errors, props.id)} detail={false} {...props} />;
};

export const UsersItemEditable = memo(UsersItemEditableBase) as typeof UsersItemEditableBase;
